module.exports = __webpack_public_path__ + "static/img/ee.6088c9ce.svg";